import React from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Projectcolors from "../../Utils/Colors";
import HomeIcon from '@mui/icons-material/Home';
import HelpIcon from '@mui/icons-material/Help';
import Selexlogo from '../../images/SelexSIM.png';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { create } from '../../Store/projectPermission/permssionReducer';
import Tooltip from "@mui/material/Tooltip";
import gpticon from "../../images/gpticon.png";






function SelexAnalysisNavbar(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation();


  function logout(){
    sessionStorage.removeItem("usertoken");
    sessionStorage.removeItem("projectID");
    sessionStorage.removeItem("projectName");
    dispatch(create([{empty:true}]))

    if (props.admin){
      navigate("/admin");

    }
    else{
      navigate("/login");
    }
  }
  return (
    <div style={{paddingBottom:"60px"}}>    
    <Box>
    <AppBar  sx={{backgroundColor:'white',height:65}} >
      <Toolbar sx={{position:"sticky"}}>
      <a href="/selectselexsim" style={{padding:'10px'}}><img alt="logo" style = {{ height:'55px',width:'60px',marginTop:'0px',marginleft:'3px',background:'white'}} src = {Selexlogo}/></a>
      {location.pathname == "/newanalysisproject" ?(
          <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          href="/selectselexsim"
          
          
        >
          <HomeIcon  sx={{fontSize:63,borderLeft: '0.01em solid white',marginLeft:0.5,paddingLeft:1,color:Projectcolors.primary}} />
        </IconButton>
      ):( <IconButton
         edge="start"
         color="inherit"
         aria-label="menu"
         href="/selectselexsim"
         
         
       >
         <HomeIcon  sx={{fontSize:63,borderLeft: '0.01em solid white',marginLeft:0.5,paddingLeft:1,color:Projectcolors.primary}} />
       </IconButton>)}


       
              <div style={{display: "block",
          marginLeft: "41%",
          marginRight: "auto"}}
 >      
        <Typography sx={{fontSize:22,color:Projectcolors.primary,display:'inline',marginTop:2}}>Selex<span style={{color:"#9e0b22"}}>SIM™</span></Typography>
      </div>

      <Tooltip
                                title={
                                  <Typography fontSize={15}>
                                    SelexGPT
                                  </Typography>
                                }
                                sx={{ fontSize: 15 }}
                              >
                                 <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          href="/gpt"
           
        >
          <img
                alt="model"
                src={gpticon}
                style={{
                  marginRight: 10,
                  height:34,
                  width:34
                }}
              />
        </IconButton>
                                
                              </Tooltip>
     
                              <Tooltip
                                title={
                                  <Typography fontSize={15}>
                                    Help
                                  </Typography>
                                }
                                sx={{ fontSize: 15 }}
                              >
       
      <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          href="/selexsim-help"
           
        >

          <HelpIcon  sx={{fontSize:"24px",marginLeft:"20px",marginRight:"10px",color:Projectcolors.primary}} />
        </IconButton>
        </Tooltip>

        <Tooltip
                                title={
                                  <Typography fontSize={15}>
                                    Logout
                                  </Typography>
                                }
                                sx={{ fontSize: 15 }}
                              >
        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
        >
          <LogoutIcon onClick={logout}  sx={{fontSize:"24px",marginLeft:"20px",marginRight:"10px",color:Projectcolors.primary}} />
        </IconButton>
        </Tooltip>


      </Toolbar>
    </AppBar>
  </Box>
</div>
  )
}

export default SelexAnalysisNavbar